<template>
	<div class="topbar">
		<a @click='goback'>返回上一頁</a>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){

			},
			goback(){
				this.$router.go(-1)
			}
		},
	}
</script>

<style lang='scss' scoped>
@import '@/style/common';
@import '@/style/mixin';
	.topbar {
		background-color: #F3F4F5;
		padding: 0 10vw;
		a {
			display:block;
			line-height: 40px;
			margin: auto;
			&:hover {
				color: $theme-color;
			}
		}
	}
	//移動版樣式
	@media (max-width: 768px){
		.topbar {
			padding: 0 2vw;
		}
	}
</style>